<template>
	<div id="maillst" class="pub_pub">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/txl.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/txl_font.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>通讯</span><span style="color:#D7230C;">录</span></div>
					<div class="sm_pub">获取商务人士联系方式</div>
				</div>
			</div>
			<router-link tag="div" class="ckgd" to="/maillistdetails">
				查看更多&nbsp;>
			</router-link>
		</div>
		<el-carousel style="box-shadow: 0 4px 24px rgba(0,0,0,.16);margin-top: 10px;" :interval="5000" arrow="none">
			<el-carousel-item v-for="(item,index) in 3" :key="index">
				<div class="z_warp">
					<!-- 	<router-link tag="div" :to="{ path:'/txldetail',query:{id:o.id,title:o.title} }" class="lb_cont"
						v-for="(o,index) in xptjlist[index]" :key="index"> -->
					<div class="lb_cont" v-for="(o,index) in xptjlist[index]" :key="index">
						<div class="list_lb_img">
							<img src="../imges/mpxgt.png" style="filter: blur(5px);" alt="">
						</div>
						<div class="xp_title" style="text-align: center;">
							{{o.company}}
						</div>
						<div class="xp_ms xm_mpsm">
							<div style="height: 20px;">
								{{o.position}} &nbsp; *{{o.title.slice(-1)}}
							</div>
							<div style="height: 20px;">
								手机： ****{{`${o.phone}`.substring(4,7)}}****
							</div>
						</div>
						<!-- @click="zxcvasdfqwer(o.id)" -->
						<div class="ckxq_xp" @click="das(o.id,o.title)">
							<!-- 付费查看 el-icon-thumb -->
							<i class="el-icon-thumb"></i>
						</div>
					</div>
				</div>
			</el-carousel-item>
		</el-carousel>

		<dashang ref="dashang"></dashang>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: '',
				sid: '',
			}
		},
		methods: {
			async das(id, sb) {
				let that = this
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				this.sid = loginInfo.id
				if (loginInfo) {
					let res = await http.post('api/picture/login_yz', {
						tid: id,
						nologin_type: 'txl',
						uid: loginInfo.id
					})

					console.log(res)
					if (res.data.code == 500) {
						this.$refs.dashang.DS_ck(20, '通讯录查看', 'txl', id)
						// that.$refs.child.isShowZF = true //修改子组件data
					} else {
						this.$router.push({
							path:`/txldetail?id=${id}&title=${sb},`
						})
					}
				} else {
					this.$message.error('请先登录');
					this.$router.replace('/login')
				}
			},
		},
		components: {
			//打赏
			dashang: resolve => require(['@/components/dashang/dashangs.vue'], resolve),
		},
		async mounted() {
			let res = await http.post('api/Common/index', {
				model: 'bscard',
				type: 'content',
				mid: '5',
				rows_limit: '15'
			})
			let xpList = res.data.data.list.data
			let newArr = [
				[],
				[],
				[]
			]
			xpList.forEach((item, index) => {
				if (index < 4) {
					newArr[0].push(item)
				} else if (index >= 4 && index < 8) {
					newArr[1].push(item)
				} else if (index >= 8 && index < 12) {
					newArr[2].push(item)
				}
			})
			this.xptjlist = newArr
		}
	}
</script>

<style>
	#maillst {
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
	}

	/* 头部 */
	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
	}

	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.img_logo>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub>ul::after {
		content: '';
		display: block;
		clear: both;
	}

	.sm_pub {
		float: left;
		margin-left: 40px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.ct_title {
		float: left;

	}

	.ct_img {
		float: left;
		margin-left: 10px;
	}

	.ct_img>img {
		width: 12px;
		height: 10px;
	}

	.ckgd {
		float: right;
		margin-right: 20px;
		color: #999999;
		font-size: 15px;
		height: 36px;
		line-height: 46px;
		cursor: pointer;
	}

	/* 结尾 */

	.z_warp::after {
		content: '';
		display: block;
		clear: both;
	}

	#maillst .lb_cont {
		float: left;
		width: calc((100% - 120px)/4);
		margin-left: 24px;
		height: 330px;
		border: 1px solid #ececec;
	}

	.list_lb_img {
		height: 150px;
	}

	.list_lb_img>img {
		width: 100%;
		height: 100%;
	}

	.xp_title {
		margin-left: 8px;
		font-size: 16px;
		font-weight: 600;
		margin-top: 12px;
		margin-bottom: 8px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}

	.ckxq_xp {
		width: 80px;
		border: 1px solid #ff4400;
		color: #ff4400;
		text-align: center;
		padding: 2px 0px;
		margin: 10px auto;
		cursor: pointer;
	}

	#maillst /deep/.el-carousel__container {
		height: 350px;
		margin-top: 20px;
	}

	.xp_ms {
		margin-left: 8px;
		font-size: 14px;
		text-overflow: -o-ellipsis-lastline;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
	}

	.xm_mpsm {
		height: 40px;
		line-height: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		text-align: center;
	}


	.ckxq_xp {
		width: 80px;
		border: 1px solid #ff4400;
		color: #ff4400;
		text-align: center;
		padding: 2px 0px;
		margin: 10px auto;
		cursor: pointer;
	}
</style>
